import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories } from '@/mocks/categories';
import { articles, getArticlesByCategory } from '@/mocks/articles';

const categoryHeroImages: Record<string, string> = {
  'wanghong-fanche': 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20coral%20red%20and%20deep%20charcoal%20gradients%2C%20flowing%20organic%20shapes%2C%20modern%20editorial%20design%20aesthetic%2C%20soft%20textured%20overlay%2C%20dramatic%20atmosphere%2C%20clean%20minimalist%20composition%2C%20magazine%20cover%20style&width=1800&height=800&seq=category-hero-wanghong-fanche&orientation=landscape',
  'yulequan': 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20golden%20amber%20and%20cream%20gradients%2C%20flowing%20organic%20shapes%2C%20modern%20editorial%20design%20aesthetic%2C%20soft%20textured%20overlay%2C%20sophisticated%20atmosphere%2C%20clean%20minimalist%20composition%2C%20magazine%20cover%20style&width=1800&height=800&seq=category-hero-yulequan&orientation=landscape',
  'zuixin-dagua': 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20vibrant%20coral%20and%20deep%20burgundy%20gradients%2C%20flowing%20organic%20shapes%2C%20modern%20editorial%20design%20aesthetic%2C%20soft%20textured%20overlay%2C%20bold%20dramatic%20atmosphere%2C%20clean%20minimalist%20composition%2C%20magazine%20cover%20style&width=1800&height=800&seq=category-hero-zuixin-dagua&orientation=landscape',
  'dujia-baoliao': 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20olive%20green%20and%20warm%20sand%20gradients%2C%20flowing%20organic%20shapes%2C%20modern%20editorial%20design%20aesthetic%2C%20soft%20textured%20overlay%2C%20mysterious%20atmosphere%2C%20clean%20minimalist%20composition%2C%20magazine%20cover%20style&width=1800&height=800&seq=category-hero-dujia-baoliao&orientation=landscape',
  'remen-shipin': 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20terracotta%20and%20cream%20gradients%2C%20flowing%20organic%20shapes%2C%20modern%20editorial%20design%20aesthetic%2C%20soft%20textured%20overlay%2C%20energetic%20atmosphere%2C%20clean%20minimalist%20composition%2C%20magazine%20cover%20style&width=1800&height=800&seq=category-hero-remen-shipin&orientation=landscape',
};

const categoryCtaImages: Record<string, string> = {
  'wanghong-fanche': 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20coral%20and%20cream%20gradients%2C%20soft%20organic%20shapes%2C%20modern%20editorial%20design%2C%20clean%20minimalist%20aesthetic%2C%20sophisticated%20textured%20background&width=1000&height=700&seq=cta-cat-wanghong-fanche&orientation=landscape',
  'yulequan': 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20golden%20and%20cream%20gradients%2C%20soft%20organic%20shapes%2C%20modern%20editorial%20design%2C%20clean%20minimalist%20aesthetic%2C%20sophisticated%20textured%20background&width=1000&height=700&seq=cta-cat-yulequan&orientation=landscape',
  'zuixin-dagua': 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20vibrant%20coral%20and%20cream%20gradients%2C%20soft%20organic%20shapes%2C%20modern%20editorial%20design%2C%20clean%20minimalist%20aesthetic%2C%20sophisticated%20textured%20background&width=1000&height=700&seq=cta-cat-zuixin-dagua&orientation=landscape',
  'dujia-baoliao': 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20olive%20green%20and%20cream%20gradients%2C%20soft%20organic%20shapes%2C%20modern%20editorial%20design%2C%20clean%20minimalist%20aesthetic%2C%20sophisticated%20textured%20background&width=1000&height=700&seq=cta-cat-dujia-baoliao&orientation=landscape',
  'remen-shipin': 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20terracotta%20and%20cream%20gradients%2C%20soft%20organic%20shapes%2C%20modern%20editorial%20design%2C%20clean%20minimalist%20aesthetic%2C%20sophisticated%20textured%20background&width=1000&height=700&seq=cta-cat-remen-shipin&orientation=landscape',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = getArticlesByCategory(slug || '');
  const heroImg = category ? (categoryHeroImages[category.slug] || 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20olive%20green%20and%20cream%20gradients%2C%20flowing%20organic%20shapes%2C%20modern%20editorial%20design%20aesthetic%2C%20soft%20textured%20overlay%2C%20sophisticated%20atmosphere%2C%20clean%20minimalist%20composition%2C%20magazine%20cover%20style&width=1800&height=800&seq=category-hero-default&orientation=landscape') : '';
  const ctaImg = category ? (categoryCtaImages[category.slug] || 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20coral%20and%20cream%20gradients%2C%20soft%20organic%20shapes%2C%20modern%20editorial%20design%2C%20clean%20minimalist%20aesthetic%2C%20sophisticated%20textured%20background&width=1000&height=700&seq=cta-cat-default&orientation=landscape') : '';

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-[60vh] flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-900 mb-2">分类不存在</h1>
            <Link to="/" className="text-sm text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main>
        <section className="relative w-full h-[360px] md:h-[440px] overflow-hidden mx-auto px-4 md:px-6 pt-20">
          <div className="relative w-full h-full rounded-3xl overflow-hidden">
            <img
              src={heroImg}
              alt={category.name}
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
              <nav className="flex items-center gap-2 text-white/70 text-xs mb-4" aria-label="面包屑导航">
                <Link to="/" className="hover:text-white transition-colors cursor-pointer">首页</Link>
                <i className="ri-arrow-right-s-line"></i>
                <span className="text-white">{category.name}</span>
              </nav>
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/25 bg-white/10 backdrop-blur-sm mb-4">
                <i className={`${category.icon} text-primary-400 text-sm`}></i>
                <span className="text-white/90 text-xs font-medium">分类浏览</span>
              </div>
              <h1 className="text-3xl md:text-5xl font-bold font-heading text-white">
                {category.name}
              </h1>
              <p className="mt-3 text-sm text-white/70 max-w-lg">{category.description}</p>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-20 px-4 md:px-6">
          <div className="mx-auto max-w-7xl">
            <div className="flex items-center justify-between mb-8">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
                全部{category.name}爆料
                <span className="text-sm font-normal text-foreground-500 ml-2">
                  （共{categoryArticles.length}篇）
                </span>
              </h2>
            </div>

            {categoryArticles.length === 0 ? (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无内容，敬请期待</p>
                <Link to="/" className="mt-4 inline-block text-sm text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {categoryArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer flex flex-col"
                  >
                    <div className="relative h-52 overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                      {article.isHot && (
                        <div className="absolute top-3 left-3">
                          <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium">
                            <i className="ri-fire-line text-[10px]"></i>热
                          </span>
                        </div>
                      )}
                      {article.isVideo && (
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                            <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="flex-1 p-5 flex flex-col">
                      <h3 className="text-base font-bold font-heading text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                        {article.title}
                      </h3>
                      <p className="text-sm text-foreground-600 line-clamp-2 mb-4">{article.excerpt}</p>
                      <div className="mt-auto flex items-center justify-between text-xs text-foreground-500">
                        <span>{article.publishDate}</span>
                        <div className="flex items-center gap-3">
                          <span><i className="ri-eye-line mr-0.5"></i>{(article.viewCount / 10000).toFixed(1)}万</span>
                          <span><i className="ri-chat-3-line mr-0.5"></i>{article.commentCount}</span>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="mx-auto max-w-7xl">
            <div className="flex flex-col lg:flex-row gap-0 rounded-2xl overflow-hidden">
              <div className="lg:w-1/2 relative h-64 md:h-80 lg:h-auto overflow-hidden">
                <img
                  src={ctaImg}
                  alt="订阅更多爆料"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent"></div>
                <div className="absolute left-6 top-6">
                  <span className="inline-block px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium">
                    更多爆料
                  </span>
                </div>
                <div className="absolute left-6 bottom-6">
                  <p className="text-2xl md:text-3xl font-bold font-heading text-white leading-tight">
                    还有更多<br />精彩内容
                  </p>
                </div>
              </div>
              <div className="lg:w-1/2 bg-background-100 flex flex-col items-center justify-center text-center p-8 md:p-12 lg:p-14">
                <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-4">
                  查看更多分类
                </h3>
                <p className="text-sm text-foreground-600 max-w-md mb-8 leading-relaxed">
                  除了{category.name}，我们还有更多精彩分类等你探索。娱乐圈、独家爆料、热门视频……总有一款适合你。
                </p>
                <div className="flex flex-wrap items-center justify-center gap-2">
                  {categories.filter(c => c.slug !== slug).map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="whitespace-nowrap px-4 py-2 rounded-full bg-background-200/70 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}